import { create } from 'zustand'
import { api } from '@/lib/api'

export interface NotificationItem {
  id: string
  title: string
  body?: string
  type?: string
  read?: boolean
  created_at?: string
}

interface NotificationState {
  items: NotificationItem[]
  fetch: () => Promise<void>
  addItem: (item: NotificationItem) => void
  markRead: (id: string) => void
  markAllRead: () => void
  unreadCount: () => number
}

export const useNotificationStore = create<NotificationState>((set, get) => ({
  items: [],

  unreadCount: () => get().items.filter((n) => !n.read).length,

  fetch: async () => {
    try {
      const res = await api.get<NotificationItem[]>('/api/v1/notifications')
      const list = Array.isArray(res) ? res : (res as any)?.items ?? []
      set({ items: list })
    } catch {
      set({ items: [] })
    }
  },

  addItem: (item: NotificationItem) => {
    // Prepend; deduplicate by id
    set((state) => ({
      items: [item, ...state.items.filter((n) => n.id !== item.id)],
    }))
  },

  markRead: (id: string) => {
    set({ items: get().items.map((i) => (i.id === id ? { ...i, read: true } : i)) })
    api.post(`/api/v1/notifications/${id}/read`, {}).catch(() => {})
  },

  markAllRead: () => {
    set({ items: get().items.map((i) => ({ ...i, read: true })) })
    api.post('/api/v1/notifications/read-all', {}).catch(() => {})
  },
}))
